registerComponent("empty", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio — em 2020 era um `$(component)` comentado. O
 * componente existe vazio de propósito: é o esqueleto que o
 * `make:ui-component` produz, e o `UnreferencedComponentsTest` trava o markup
 * dele à letra (`<div data-component-name="empty" > </div>`).
 */

});
